import { getFinancialUser, getFinancialAppeal, deleteFinancialAppeal,
  getFinancialCrm, addFinancialCrm, updateFinancialCrm,
  getFinancialContactDetail, addFinancialContactDetail,
  updateFinancialContactDetail, getFinancialAggregate, emptyFinancialManage,
  updateFinancialContactMark, getPurchaseAndSalesContactDetail, addPurchaseAndSalesContactDetail, updatePurchaseAndSalesContactDetail, getPurchaseAndSalesCrm,
  addPurchaseAndSalesCrm, updatePurchaseAndSalesCrm, getPurchaseAndSaleUser, getAgentUserCircle, getPurchaseAndSaleAggregate, deleteFinancialAllAppeal, updatePurchaseAndSaleContactMark, addAdminUsers } from '@/api/financial'

const financial = {
  state: {
    total: 0,
    rows: [],
    row: {},
    grouprows: [],
    crm: {},
    dicts: {},
    financialCompany: []
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_GROUPROWS: (state, grouprows) => {
      state.grouprows = grouprows
    },
    SET_CRM: (state, crm) => {
      state.crm = crm
    },
    SET_DICTS: (state, dicts) => {
      state.dicts = dicts
    },
    SET_FINANCIALROWS: (state, financialCompany) => {
      state.financialCompany = financialCompany
    }
  },
  actions: {
    // 获取金融信息
    GetFinancialUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFinancialUser(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取金融信息各个诉求
    GetFinancialAppeal({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFinancialAppeal(params).then(response => {
          commit('SET_FINANCIALROWS', response.Data.FinancialRows)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除金融信息各个诉求
    DeleteFinancialAppeal({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteFinancialAppeal(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除金融信息各个诉求
    DeleteFinancialAllAppeal({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteFinancialAllAppeal(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取CRM
    GetFinancialCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFinancialCrm(params).then(response => {
          commit('SET_CRM', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加CRM
    AddFinancialCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        addFinancialCrm(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改CRM
    UpdateFinancialCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateFinancialCrm(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取联系人详情
    GetFinancialContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFinancialContactDetail(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加联系人详情
    AddFinancialContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        addFinancialContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改联系人详情
    UpdateFinancialContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateFinancialContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 合计部分
    GetFinancialAggregate({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFinancialAggregate(params).then(response => {
          commit('SET_DICTS', response.Data.Dict)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清空新金融状态
    EmptyFinancialManage({ commit }, params) {
      return new Promise((resolve, reject) => {
        emptyFinancialManage(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新标记
    UpdateFinancialContactMark({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateFinancialContactMark(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 现货代理采销
    // 获取联系人详情
    GetPurchaseAndSalesContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPurchaseAndSalesContactDetail(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取采销信息
    GetPurchaseAndSaleUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPurchaseAndSaleUser(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户采销信息
    GetAgentUserCircle({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAgentUserCircle(params).then(response => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加联系人详情
    AddPurchaseAndSalesContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        addPurchaseAndSalesContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改联系人详情
    UpdatePurchaseAndSalesContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePurchaseAndSalesContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取CRM
    GetPurchaseAndSalesCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPurchaseAndSalesCrm(params).then(response => {
          commit('SET_CRM', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加CRM
    AddPurchaseAndSalesCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        addPurchaseAndSalesCrm(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改CRM
    UpdatePurchaseAndSalesCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePurchaseAndSalesCrm(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 合计部分
    GetPurchaseAndSaleAggregate({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPurchaseAndSaleAggregate(params).then(response => {
          commit('SET_DICTS', response.Data.Dict)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新标记
    UpdatePurchaseAndSaleContactMark({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePurchaseAndSaleContactMark(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 后台查看人ID
    AddAdminUsers({ commit }, params) {
      return new Promise((resolve, reject) => {
        addAdminUsers(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default financial



// WEBPACK FOOTER //
// ./src/store/modules/financial.js